import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import LdsTile from "../../components/LdsTile";
import References from "../../components/References";
import LdsDivider from "../../components/LdsDivider";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_2_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-9">
        <main>
          <section className="mb-5">
            <h1 className="blue text-uppercase b mt-5">
              1.2.1 Amyvid Was Evaluated in 3 Pivotal Studies
            </h1>
            <p className="mt-1 mb-0">Estimated time to complete: 1 minute</p>
          </section>
          <section className="mb-5 row">
            <div className="row equal-height-row d-flex flex-wrap">
              <div className="col-md-4 p-4 d-flex flex-column">
                <LdsTile
                  className="gray-tile d-flex no-shadow fancy-border"
                  style={{ height: "100%" }}
                >
                  <div className="m-4 p-2">
                    <h1 className="h5 b black text-center">Reliable</h1>
                    <p className="text-center mb-4">Study 1</p>

                    <LdsDivider className="black" />
                    <p className="mt-4 mb-4 text-center">
                      Assessed the correlation between amyloid plaques seen at
                      autopsy and estimates for amyloid plaque density using
                      Amyvid PET imaging
                    </p>
                    <LdsDivider className="black" />
                    <p className="mt-4 b text-center">Design</p>
                    <ul
                      className="text-start ms-0 mb-4 ps-4"
                      style={{ minHeight: "115px" }}
                    >
                      <li>3 readers</li>
                      <li>
                        Semiquantitative reading methodology (not intended for
                        clinical use)
                      </li>
                    </ul>
                    <LdsDivider className="black" />
                    <p className="mt-4 b text-center">Population</p>
                    <p className="text-center">
                      35 terminally ill patients who received premortem Amyvid
                      scans and then underwent autopsy (29 of whom comprised the
                      primary analysis set)
                    </p>
                  </div>
                </LdsTile>
              </div>
              <div className="col-md-4 p-4 d-flex flex-column">
                <LdsTile
                  className="gray-tile d-flex no-shadow fancy-border text-center"
                  style={{ height: "100%" }}
                >
                  <div className="m-4 p-2">
                    <h1 className="h5 b black">Accurate</h1>
                    <p className="mb-4">Study 2</p>
                    <LdsDivider className="black" />
                    <p className="mt-4 mb-4">
                      Assessed the inter- and intra-reader image interpretation
                      reproducibility in subjects with and without autopsy
                      (truth standard)
                    </p>
                    <LdsDivider className="black" />
                    <p className="mt-4 b">Design</p>
                    <ul
                      className="text-start ml-0 mb-4 ps-4"
                      style={{ minHeight: "115px" }}
                    >
                      <li>5 readers (trained in person)</li>
                      <li>Binary visual read methodology</li>
                    </ul>
                    <LdsDivider className="black" />
                    <p className="mt-4 b">Population</p>
                    <p>
                      59 terminally ill patients* who received premortem Amyvid
                      scans and then underwent autopsy to establish a truth
                      standard
                    </p>
                  </div>
                </LdsTile>
              </div>
              <div className="col-md-4 p-4 d-flex flex-column">
                <LdsTile
                  className="gray-tile d-flex no-shadow fancy-border text-center"
                  style={{ height: "100%" }}
                >
                  <div className="m-4 p-2">
                    <h1 className="h5 b black">Reproducible</h1>
                    <p className="mb-4">Study 3</p>
                    <LdsDivider className="black" />
                    <p className="mt-4 mb-4">
                      Assessed the inter- and- intra reader image interpretation
                      reproducibility in subjects with and without autopsy
                      (truth standard)
                    </p>
                    <LdsDivider className="black" />
                    <p className="mt-4 b">Design</p>

                    <ul
                      className="text-start ml-0 mb-4 ps-4"
                      style={{ minHeight: "115px" }}
                    >
                      <li>5 readers (trained in person)</li>
                      <li>Binary visual read methodology</li>
                    </ul>
                    <LdsDivider className="black" />
                    <p className="mt-4 b">Population</p>
                    <p>
                      92 subjects<sup>†</sup> who did not undergo autopsy (truth
                      standard) in addition to 59 patients (same population from
                      Study 2) with autopsy data
                    </p>
                    <p>
                      33 randomly selected images were used to assess
                      intra-reader reproducibility
                    </p>
                  </div>
                </LdsTile>
              </div>
            </div>
          </section>
          <section className="button-control row mb-0">
            <div className="col-sm-12">
              <LdsButton classes="white-button mt-3 mb-5 prev" onClick={function navClick() { window.open("/module-1/module-1-1-2", "_self") }}>
                Previous Lesson
              </LdsButton>
              <LdsButton
                classes="blue-button mt-3 mb-5 align-self-right float-end next"
                onClick={function navClick() {
                  window.open("/module-1/module-1-2-2", "_self");
                }}
              >
                Next Lesson
              </LdsButton>
            </div>
          </section>
          <section className="row mt-0 mb-5">
            <p className="fz-sm">
              *29 patients had an AD clinical diagnosis, 13 had another type of
              dementing disorder, 12 had no history of cognitive impairment, and
              5 had mild cognitive impairment (MCI).
            </p>
            <p className="fz-sm">
              <sup>†</sup>20 healthy volunteers, 52 patients with MCI, and 20
              patients with AD.
            </p>
          </section>
          <References>
            <p className="no-indent fz-sm">
              Amyvid (florbetapir F 18 injection) Prescribing Information. Lilly
              USA, LLC.
            </p>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_1_2_1;
